<template>
    <section
        v-if="content"
        class="c-case-study-hero"
    >
        <y-row>
            <y-col md="7">
                <h1
                    v-if="content.title"
                    class="c-case-study-hero__title"
                >
                    {{ content.title }}
                </h1>
                <p
                    v-if="content.synopsis"
                    class="c-case-study-hero__description"
                >
                    {{ content.synopsis }}
                </p>
                <div class="c-case-study-hero__action">
                    <a
                        v-if="album && album['link']"
                        class="case-study-customer-action"
                        :href="album['link']"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <y-button
                            tag="button"
                            :content="$t('case-studies.download_button')"
                            color="primary"
                            size="medium"
                            flat
                            :no-padding="false"
                        />
                    </a>
                </div>
            </y-col>
            <y-col
                md="5"
                class="c-case-study-hero__image-container"
            >
                <div
                    v-if="content.custom.video"
                    v-html="content.custom.video"
                />
                <img
                    v-else-if="content.image"
                    class="case-study-hero-img"
                    :src="imgSrc(content.image,'main')"
                >
            </y-col>
        </y-row>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'CaseStudySingleHero',
        props: {
            content: {
                type   : Object,
                default: () => {},
            },
            album: {
                type   : Object,
                default: () => {},
            },
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss" />
